import React, { Fragment } from 'react';

import { SFChip } from 'sfui';

export interface ReportableChipProps {
  isReportable?: boolean;
  size?: 'small' | 'tiny';
}

export const ReportableChip = ({
  isReportable = true,
  size = 'small'
}: ReportableChipProps): React.ReactElement<ReportableChipProps> => {
  return (
    <Fragment>
      {isReportable && (
        <SFChip
          label="Reportable to the state"
          variant="outlined"
          size={size}
          sfColor="primary"
        />
      )}
      {!isReportable && (
        <SFChip
          label="Not reportable to the state"
          variant="outlined"
          size={size}
          sfColor="grey"
        />
      )}
    </Fragment>
  );
};
